import React from 'react';
import { useTranslations } from '@core/js/hooks/i18n';
import { ITranslateMethod } from '@core/js/hooks/i18n/types';

type TI18nProps = {
    tKey?: string;
    replacers?: (string | number)[];
    defaultValue?: string;
    className?: string;
    onClick?: () => void;
    t?: ITranslateMethod;
}

export const I18n: React.FC<TI18nProps> = ({
    tKey = '',
    replacers = [],
    defaultValue = '',
    className = '',
    onClick,
    t
}) => {
    const defaultTranslate = useTranslations();
    const tt = t || defaultTranslate;
    const tValue = tt(tKey, replacers, defaultValue);

    if (!tValue) {
        return null;
    }

    return (
        <span
            className={className}
            dangerouslySetInnerHTML={{ __html: tValue }}
            {...onClick && { onClick }}
        />
    );
};

export default I18n;
